import React, { useContext, useEffect, useState } from "react";

import { useRouter } from "next/router";

import { motion } from "framer-motion";

import GlobalContext from "shared/providers/context/GlobalContext";
import { echo } from "shared/utils/echo";
import { getGamificationCoinIcon } from "shared/utils/getGamificationCoinIcon";
import { useAuthContext } from "shared/utils/hooks/useAuthContext";
import { useFeature } from "shared/utils/hooks/useFeature";

import { ExpStarIcon } from "../../../assets/ExpStarIcon";
import { GamificationInfosContainer } from "./styles";

const GamificationInfos = () => {
  const isStoreFeatureFlagEnabled = useFeature("f_rewards_shop");
  const router = useRouter();
  const {
    loggedUser: user,
    userCoins,
    setUserCoins,
    userPoints,
    setUserPoints,
    setShouldCalculateUserPositionInRanking,
  } = useAuthContext();
  const { state } = useContext(GlobalContext);

  useEffect(() => {
    if (!!user && !userCoins && !userPoints) {
      setUserCoins(user?.total_coins);
      setUserPoints(user?.total_points);
    }
  }, [userCoins, userPoints]);

  const [showCoins, setShowCoins] = useState(false);
  const [showPoints, setShowPoints] = useState(false);

  const [addedCoins, setAddedCoins] = useState(null);
  const [addedPoints, setAddedPoints] = useState(null);

  const gamificationData = state?.tenancy?.settings?.gamification;

  const isStoreEnabled = gamificationData?.enableRewardsShop == 1;
  const isTriggersEnabled = gamificationData?.enableTriggers == 1;

  const coinsColor = gamificationData?.coinsColor;
  const coinIcon = getGamificationCoinIcon(gamificationData?.coinsIcon);

  const formatedUserCoins = userCoins?.toLocaleString("pt-BR");
  const formatedUserPoints = userPoints?.toLocaleString("pt-BR");

  const shouldWarminUp = userPoints < 10;

  const userID = user?.id;

  const shouldShowCoins =
    isStoreFeatureFlagEnabled &&
    isStoreEnabled &&
    typeof userCoins === "number";

  useEffect(() => {
    const tenantUuid = state?.tenancy?.uuid;

    echo
      ?.channel(`gamification-triggers.${tenantUuid}`)
      ?.listen("TriggerNotification", (data) => {
        if (data?.activity?.user_id === userID) {
          if (data?.activity?.coins) {
            setShowCoins(true);
            setAddedCoins(data?.activity?.coins);
            setUserCoins(userCoins + parseInt(data?.activity?.coins));
            setTimeout(() => {
              setShowCoins(false);
              setAddedCoins(null);
            }, 2000);
          }

          if (data?.activity?.points) {
            setShowPoints(true);
            setAddedPoints(data?.activity?.points);
            setUserPoints(userPoints + parseInt(data?.activity?.points));
            setShouldCalculateUserPositionInRanking(true);
            setTimeout(() => {
              setShowPoints(false);
              setAddedPoints(null);
            }, 2000);
          }
        }
      });

    return () => {
      if (echo) {
        echo.leaveChannel(`gamification-triggers.${tenantUuid}`);
      }
    };
  }, [echo, userCoins, userPoints]);

  return (
    <GamificationInfosContainer
      coinsColor={coinsColor}
      shouldWarminUp={shouldWarminUp}
    >
      {shouldShowCoins && (
        <div className="coins-section">
          <div
            className="coins"
            onClick={
              shouldWarminUp && isTriggersEnabled
                ? () => router.push("/about-points")
                : null
            }
          >
            {coinIcon[0]?.icon}
            <p>{formatedUserCoins}</p>
          </div>
          {showCoins && (
            <motion.div
              className="gained-coins"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: [0, 1, 0], y: [50, 0] }}
              exit={{ opacity: 0, y: -50 }}
              transition={{ duration: 2 }}
            >
              {coinIcon[0]?.icon}
              <p>+ {addedCoins}</p>
            </motion.div>
          )}
        </div>
      )}

      {typeof userPoints === "number" && (
        <div className="exp-section">
          <div
            className="exp"
            onClick={
              shouldWarminUp && isTriggersEnabled
                ? () => router.push("/about-points")
                : null
            }
          >
            <ExpStarIcon />
            <p>{formatedUserPoints}</p>
          </div>
          {showPoints && (
            <motion.div
              className="gained-exp"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: [0, 1, 0], y: [50, 0] }}
              exit={{ opacity: 0, y: -50 }}
              transition={{ duration: 2 }}
            >
              <ExpStarIcon />
              <p>+ {addedPoints}</p>
            </motion.div>
          )}
        </div>
      )}
    </GamificationInfosContainer>
  );
};

export default GamificationInfos;
